export enum ELocalStorage {
    FILTERS = 'filters',
    RECENTLY = 'recently'
}
